import { Magnet } from 'lucide-react';
import { Button } from '~/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { useStore } from '~/store';

export function SnapToggleChip() {
  const enabled = useStore((s) => s.editor.snapToGuidelines);
  const setEnabled = useStore((s) => s.setSnapToGuidelines);
  const label = enabled ? 'Snap to guidelines (on)' : 'Snap to guidelines (off)';
  return (
    <div className="pointer-events-auto absolute right-2 top-2 z-10">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="icon-xs"
            variant={enabled ? 'default' : 'outline'}
            aria-label={label}
            aria-pressed={enabled}
            onClick={() => setEnabled(!enabled)}
            className="h-7 w-7 shadow"
          >
            <Magnet className="h-3.5 w-3.5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          {label}
          <span className="ml-1 text-muted-foreground">(S)</span>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
